module.exports = __webpack_public_path__ + "school/img/chuanchegn.8d56a530.png";